(function () {
  var root = document.querySelector('[data-wp]'); if (!root) return;
  var D = {}; try { D = JSON.parse(root.querySelector('[data-wp-data]').textContent); } catch (e) { return; }
  var KEY = 'demc_welcome', force = !!window.DEMC_FORCE_POPUP || /[?&]welcome=1/.test(location.search);
  var box = root.querySelector('[data-wp-box]'), pool = (D.cards || []).map(function (t) { return t.replace(/^\s+|\s+$/g, ''); }).filter(Boolean), cards = pool.slice();
  var i = 0, guilty = 0, busy = false, shown = false, last = null;
  function deal() {
    var a = pool.slice(), k, t, n = a.length; while (n > 1) { k = Math.floor(Math.random() * n--); t = a[n]; a[n] = a[k]; a[k] = t; }
    cards = a.slice(0, Math.max(1, Math.min(+D.per || 5, a.length)));
    var tot = root.querySelector('[data-wp-total]'); if (tot) tot.textContent = cards.length;
  }
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function set(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  function blocked() {
    if (force) return false;
    var st = get(); if (st.done) return true;
    if (st.closed && Date.now() - st.closed < (D.days || 7) * 864e5) return true;
    if (['cart', 'customers/account', 'customers/login', 'customers/register', 'customers/order'].indexOf(D.page) > -1 || /^customers/.test(D.page || '')) return true;
    if (D.suffix === 'quiz') return true;
    if (/\/checkouts?\//.test(location.pathname)) return true;
    return false;
  }
  function screen(n) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-wp-screen]'), function (s) { s.hidden = s.getAttribute('data-wp-screen') !== n; });
    var f = root.querySelector('[data-wp-screen="' + n + '"]').querySelector('button, input, a'); if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
  }
  function open() {
    if (shown || blocked() || !cards.length) return; shown = true; last = document.activeElement;
    root.hidden = false; document.documentElement.classList.add('wp-lock'); screen('intro');
  }
  function close() {
    root.hidden = true; document.documentElement.classList.remove('wp-lock');
    var st = get(); if (!st.done) { st.closed = Date.now(); set(st); }
    if (last && last.focus) try { last.focus({ preventScroll: true }); } catch (e) {}
  }
  function draw() {
    var c = root.querySelector('[data-wp-card]'); c.className = 'wp__card';
    root.querySelector('[data-wp-text]').textContent = cards[i]; root.querySelector('[data-wp-n]').textContent = i + 1;
  }
  function answer(kind) {
    if (busy) return; busy = true; if (kind === 'guilty') guilty++;
    var c = root.querySelector('[data-wp-card]'); c.classList.add(kind === 'guilty' ? 'is-out-g' : 'is-out-n');
    setTimeout(function () { busy = false; i++; if (i >= cards.length) finish(); else draw(); }, 320);
  }
  function finish() {
    var t = guilty <= 1 ? D.r_low : guilty <= 3 ? D.r_mid : D.r_high;
    root.querySelector('[data-wp-result]').textContent = t || ''; screen('email');
  }
  function save(addr, ok, fail) {
    var props = { welcome_popup: true, welcome_offer: 'free-limoncello-car-tag', welcome_popup_guilty_count: guilty };
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: addr, welcome_popup: true, welcome_offer: props.welcome_offer, welcome_popup_guilty_count: guilty }); } catch (e) {}
    if (!D.company) { ok(); return; }
    var profile = { data: { type: 'profile', attributes: { email: addr, properties: props } } }, url, body;
    if (D.list) { url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + D.company; body = { data: { type: 'subscription', attributes: { profile: profile, custom_source: D.source || 'Welcome popup' }, relationships: { list: { data: { type: 'list', id: D.list } } } } }; }
    else { url = 'https://a.klaviyo.com/client/profiles/?company_id=' + D.company; body = profile; }
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
      .then(function (r) { if (r.ok || r.status === 202) ok(); else fail(); }).catch(fail);
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-wp-close]')) { close(); return; }
    if (e.target.closest('[data-wp-start]')) { i = 0; guilty = 0; deal(); draw(); screen('game'); return; }
    var a = e.target.closest('[data-wp-ans]'); if (a) answer(a.getAttribute('data-wp-ans'));
  });
  root.querySelector('[data-wp-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var inp = e.target.elements.email, err = root.querySelector('[data-wp-err]'), btn = e.target.querySelector('button[type=submit]'), v = (inp.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { err.textContent = D.err_email || ''; err.hidden = false; inp.focus(); return; }
    err.hidden = true; btn.classList.add('is-busy');
    save(v, function () { btn.classList.remove('is-busy'); set({ done: true }); screen('done'); },
      function () { btn.classList.remove('is-busy'); err.textContent = D.err_fail || ''; err.hidden = false; });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  if (!blocked()) {
    setTimeout(open, force ? 500 : Math.max(0, +D.delay || 0) * 1000);
    if (D.exit && !force) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0 && window.innerWidth >= 900) open(); });
  }
})();
